import { Badge, Button, Tooltip } from "flowbite-react";
import { HiTrash, HiUser } from "react-icons/hi";
import DataTable from "../Table";
import { useRemoveAgentFromGroupMutation } from "@/api/groupApi/agentGroup";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { MdAdminPanelSettings } from "react-icons/md";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { agentRoles } from "@/constants/agent";

// Define a type for the joined data if needed, or use existing types
// Usually getAgentsInGroup returns list of agents with some extra info

const GroupAgentTable = ({ data, pagination, onPageChange, groupId, onToggleAdmin }: any) => {
  const { t } = useTranslation(["group", "common"]);
  const user = useCurrentUser();
  const [removeAgent] = useRemoveAgentFromGroupMutation();

  const handleRemove = async (agentId: string) => {
    if (confirm(t("group:removeAgentConfirm"))) {
        try {
            await removeAgent({ groupId, agentId: agentId }).unwrap();
            toast.success(t("group:removeAgentSuccess"));
        } catch (error) {
            toast.error(t("group:removeAgentFail"));
        }
    }
  };

  const columns = [
    { key: "agent_username", label: t("group:username") },
    { key: "agent_email", label: t("group:email") },
    { 
        key: "role", 
        label: t("group:role"),
        render: (row: any) => (
             <Badge color={row.is_admin ? "purple" : "gray"}>
                {row.is_admin ? t("group:admin") : t("group:member")}
             </Badge>
        ) 
    },
    ...(user?.agent_role === agentRoles.company_admin ? [{
        key: "actions",
        label: t("group:actions"),
        render: (row: any) => (
            <div className="flex items-center gap-2">
                <Tooltip content={row.is_admin ? t("group:removeAdmin") : t("group:makeAdmin")}>
                    <Button 
                        size="xs" 
                        color={row.is_admin ? "warning" : "purple"} 
                        onClick={() => onToggleAdmin && onToggleAdmin(row.agent_id.toString(), !row.is_admin)}
                    >
                        {row.is_admin ? <HiUser className="h-4 w-4" /> : <MdAdminPanelSettings className="h-4 w-4" />}
                    </Button>
                </Tooltip>
                <Tooltip content={t("group:remove")}>
                    <Button size="xs" color="failure" onClick={() => handleRemove(row.agent_id.toString())}>
                        <HiTrash className="h-4 w-4" />
                    </Button>
                </Tooltip>
            </div>
        )
    }] : [])
  ];

  return (
    <DataTable
        columns={columns}
        data={data}
        pagination={pagination}
        onPageChange={onPageChange}
    />
  );
};

export default GroupAgentTable;
